import { sdkFactory as wixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscount_sdkFactory_checkoutExchange } from './src/loyalty-checkoutexchange-v1-loyalty-checkout-discount.frontend';
import { sdkFactory as wixLoyaltyImportsV1LoyaltyImport_sdkFactory_imports } from './src/loyalty-imports-v1-loyalty-import.frontend';
import { sdkFactory as wixLoyaltyTransactionV1LoyaltyTransaction_sdkFactory_transactions } from './src/loyalty-transaction-v1-loyalty-transaction.frontend';
import { sdkFactory as wixLoyaltyV1Account_sdkFactory_accounts } from './src/loyalty-v1-account.frontend';
import { sdkFactory as wixLoyaltyV1Coupon_sdkFactory_coupons } from './src/loyalty-v1-coupon.frontend';
import { sdkFactory as wixLoyaltyV1LoyaltyEarningRule_sdkFactory_earningRules } from './src/loyalty-v1-loyalty-earning-rule.frontend';
import { sdkFactory as wixLoyaltyV1Program_sdkFactory_programs } from './src/loyalty-v1-program.frontend';
import { sdkFactory as wixLoyaltyV1Reward_sdkFactory_rewards } from './src/loyalty-v1-reward.frontend';
import { sdkFactory as wixLoyaltyV1Tier_sdkFactory_tiers } from './src/loyalty-v1-tier.frontend';
export function sdkFactory(args) {
    return {
        checkoutExchange: wixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscount_sdkFactory_checkoutExchange(args),
        imports: wixLoyaltyImportsV1LoyaltyImport_sdkFactory_imports(args),
        transactions: wixLoyaltyTransactionV1LoyaltyTransaction_sdkFactory_transactions(args),
        accounts: wixLoyaltyV1Account_sdkFactory_accounts(args),
        coupons: wixLoyaltyV1Coupon_sdkFactory_coupons(args),
        earningRules: wixLoyaltyV1LoyaltyEarningRule_sdkFactory_earningRules(args),
        programs: wixLoyaltyV1Program_sdkFactory_programs(args),
        rewards: wixLoyaltyV1Reward_sdkFactory_rewards(args),
        tiers: wixLoyaltyV1Tier_sdkFactory_tiers(args),
    };
}
//# sourceMappingURL=index.frontend.js.map